import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const BTN =
  "px-4 py-2 bg-white text-[#0f172a] hover:bg-[#38bdf8] transition-all rounded font-semibold border border-[#cbd5e1]";
const ITEM =
  "block px-4 py-2.5 rounded text-xs font-ui font-semibold text-[#0f172a] hover:bg-[#f0f9ff] hover:text-[#0284c7] transition-colors";

export function MenuComunicati({ prefix = "/" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return (
    <div className="relative hidden sm:inline-block" ref={ref} data-testid="menu-comunicati">
      <button
        type="button"
        data-testid="menu-comunicati-toggle"
        onClick={() => setOpen((v) => !v)}
        className={BTN}
      >
        Comunicati e regolamenti{" "}
        <span className={`inline-block transition-transform ${open ? "rotate-180" : ""}`}>▾</span>
      </button>
      {open && (
        <div
          data-testid="menu-comunicati-panel"
          className="absolute right-0 top-full mt-1 w-60 bg-white border border-[#e2e8f0] rounded-xl shadow-lg p-2 flex flex-col gap-1 z-[60]"
        >
          <Link to="/regolamento" data-testid="menu-item-regolamento" onClick={() => setOpen(false)} className={ITEM}>
            Regolamento
          </Link>
          <Link to="/modulistica" data-testid="menu-item-modulistica" onClick={() => setOpen(false)} className={ITEM}>
            Modulistica
          </Link>
          <Link to="/giustizia-sportiva" data-testid="menu-item-giustizia" onClick={() => setOpen(false)} className={ITEM}>
            Giustizia sportiva
          </Link>
        </div>
      )}
    </div>
  );
}
